<script>
import { request } from '@api/service'
export default {
  render() {
    return (
      <el-form
        ref="form"
        {...{
          props: {
            model: this.formData,
            labelPosition: 'top',
            disabled: this.disabled,
            size:"small"
          }
        }}
      >
        <el-row gutter={this.gutter}>{this.createFormItem()}</el-row>
      </el-form>
    )
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    gutter: {
      type: Number,
      default: 20
    },
    span: {
      type: Number,
      default: 8
    },
    value: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: this.value || {}
    }
  },
  watch: {
    value(val) {
      this.formData = val || {}
    },
    formData(val) {
      this.$emit('update:value', val)
    }
  },
  methods: {
    createFormItem() {
      let forms = []
      this.items.forEach((item) => {
        forms.push(
          <el-col span={item.span || this.span}>
            <el-form-item
              label={item.title}
              prop={item.id}
              rules={this.rule(item)}
            >
              {this.createComponent(item)}
            </el-form-item>
          </el-col>
        )
      })
      return forms
    },
    createComponent(item) {
      let self = this
      let options = {
        props: { clearable: true, ...item.props, value: self.formData[item.id] },
        domProps: {
          style: 'width:100%;'
        },
        attrs: item.attrs,
        on: {
          input: function(event) {
            item.value = event
            const formData = { ...self.formData }
            formData[item.id] = event
            self.formData = formData
            // self.$emit('input', formData)
          }
        }
      }
      if (item.el === 'select') {
        return this.createSelect(item, options)
      } else if (item.el === 'cascader') {
        return this.createCascader(item, options)
      } else {
        return this.$createElement(`el-${item.el}`, options)
      }
    },
    createSelect(item, options) {
      if (item.multiple) {
        item.value = item.value ? eval(item.value) : null
      } else {
        try {
          item.value = item.value
            ? JSON.parse(eval("'" + item.value + "'"))
            : null
        } catch (error) {
          console.log()
        }
      }
      options.props.value = item.value
      return this.$createElement('dict-select', options)
    },
    createCascader(item, options) {
      item.value = item.value ? eval(item.value) : []
      options.props.value = item.value
      options.props.props = {
        ...options.props.props,
        lazyLoad(node, resolve) {
          const { level, root, value } = node
          const params = { ...item.props.params, level }
          if (value && !root) params.optionCode = value.split('|').pop()
          request({
            url: item.props.url,
            methods: 'GET',
            params
          }).then((res) => {
            const { data } = res.body
            resolve(
              data.map((t) => {
                return { label: t.label, value: `${t.label}|${t.value}` }
              })
            )
          })
        }
      }
      return this.$createElement('el-cascader', options)
    },
    rule(item) {
      const inputAlis = ['input', 'input-number']
      const isInput = inputAlis.indexOf(item.el) >= 0
      const message = isInput ? '请输入' : '请选择'
      const trigger = isInput ? 'blur' : 'change'
      return [
        {
          required: item.required,
          message: `${message}${item.title}`,
          trigger
        }
      ]
    },
    validate(callback) {
      return this.$refs.form.validate(callback)
    }
  }
}
</script>

